import { Store } from "./Store";

export interface Shopper {
  id: string;
  email: string;
  shopperId: string;
  storeId: string;
  store: Store;
  status: ShopperStatus;
}
export enum ShopperStatus {
  INACTIVE = "INACTIVE",
  ACTIVE = "ACTIVE",
}
